import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAccessToken } from "src/api/useAccessToken";
import { useSnackBar } from "src/components/Reusable/CustomSnackbarProvider";
import { useRealmApp } from "src/store/RealmApp";

export const useGetUploadLinksForFiles = () => {
  const app = useRealmApp();
  const snackbarCtx = useSnackBar();
  const queryClient = useQueryClient();
  const getValidAccessToken = useAccessToken();

  return useMutation({
    mutationFn: async (
      files: {
        id: string;
        fileName: string;
        isVisible: boolean;
        label: string;
        description: string;
        // instanceId: string;
        phaseId: string;
        taskId?: string;
        createdBy: string;
        fileType: string;
        parentFolderId?: string;
      }[]
    ): Promise<{ id: string; url: string }[]> => {
      const accessToken = await getValidAccessToken();
      const res = await axios.post(
        `${process.env.REACT_APP_SST_API_URL}/uploadLinks`,
        files,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data;
    },
    onError: () => {
      // console.log(err);
      snackbarCtx.showSnackbar("Error uploading file", "error");
    },
  });
};

export const useUploadFileToS3 = () => {
  const app = useRealmApp();
  const snackbarCtx = useSnackBar();
  const queryClient = useQueryClient();
  const getValidAccessToken = useAccessToken();

  return useMutation({
    mutationFn: async (file: {
      url: string;
      file: File;
      contentType: string;
      // fileName: string;
      // isVisible: boolean;
      // label: string;
      // description: string;
      // instanceId: string;
      // phaseId: string;
      // taskId?: string;
      // createdBy: string;
      // fileType: string;
      // parentFolderId?: string;
    }): Promise<{ message: string; id: string }> => {
      const accessToken = await getValidAccessToken();
      const res = await axios.put(`${file.url}`, file.file, {
        headers: {
          // Accept: "application/json",
          "Content-Type": file.contentType,
          // Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (progressEvent) => {
          console.log(progressEvent);
        },
      });
      return res.data;
    },
    onSuccess: () => {
      snackbarCtx.showSnackbar("File uploaded successfully", "success");
    },
    onError: () => {
      // console.log(err);
      snackbarCtx.showSnackbar("Error uploading file", "error");
    },
  });
};
